import React from 'react';
import { Flex, Image, Layout, Typography } from 'antd';
import { PrivacyBox } from './styles';
import Footer from '../_partials/Footer';

const { Title, Paragraph } = Typography;

export default function UserDataDeletion() {
  const myStyleLayout = {
    height: '100%',
    background: 'linear-gradient(90deg, #2e394b 0%, #4e6180 50%, #2e394b 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important",
  };

  return (
    <Layout className="layout" style={myStyleLayout}>
      <Flex vertical align="center" justify="center" style={{ marginTop: 20 }}>
        <Image width={170} height="auto" src="images/logo-horizontal-02.png" preview={false} />
        <Title level={8} style={{ color: '#fff' }}>
          Política de Exclusão de Dados do Usuário
        </Title>
      </Flex>
      <PrivacyBox>
        <Typography>
          <Title level={2}>Exclusão de Dados do Usuário (User Data Deletion) - Nobre Eventos</Title>
          <Paragraph>
            A Nobre Eventos respeita plenamente o direito de seus usuários à exclusão de seus dados pessoais e
            informações de uso. Entendemos que a privacidade e a segurança da informação são fundamentais, e, por isso,
            estabelecemos uma política clara e transparente em relação à exclusão definitiva de dados.
          </Paragraph>
          <Title level={3}>1. Exclusão Solicitada pelo Usuário</Title>
          <Paragraph>
            O usuário cadastrado no sistema <b>app.nobreeventos.com.br</b> poderá, a qualquer momento, solicitar a
            exclusão de sua conta e de todos os dados associados a ela. Essa solicitação poderá ser realizada por meio
            do painel do sistema (quando disponível) ou através de comunicação direta com o administrador responsável.
          </Paragraph>
          <Paragraph>
            Ao confirmar a exclusão, o sistema removerá <b>de forma irreversível</b>:
          </Paragraph>
          <ul>
            <li>Dados cadastrais (nome, e-mail, CPF/CNPJ, telefone e demais informações fornecidas);</li>
            <li>Registros de uso associados ao perfil;</li>
            <li>Permissões e acessos concedidos;</li>
            <li>Qualquer informação relacionada à conta do usuário.</li>
          </ul>
          <Paragraph>
            Após a exclusão, o usuário não terá mais acesso ao sistema e seus dados não poderão ser recuperados.
          </Paragraph>
          <Title level={3}>2. Exclusão Realizada pelo Administrador</Title>
          <Paragraph>
            Considerando que o sistema Nobre Eventos é privado e acessível apenas mediante criação de login pelo
            administrador, este poderá, a seu critério e de acordo com as políticas internas da empresa, excluir a conta
            de um usuário.
          </Paragraph>
          <Paragraph>
            Nessa situação, os mesmos critérios de exclusão definitiva de dados são aplicados, garantindo que não haja
            retenção indevida.
          </Paragraph>
          <Title level={3}>3. Irreversibilidade e Não-Armazenamento</Title>
          <Paragraph>Uma vez confirmada a exclusão:</Paragraph>
          <ul>
            <li>Todos os dados são removidos do banco de dados ativo do sistema;</li>
            <li>Não são mantidos registros ocultos, cópias paralelas ou armazenamento em segundo plano;</li>
            <li>Não há backup acessível para restauração individual da conta excluída.</li>
          </ul>
          <Paragraph>
            O processo garante a <b>eliminação completa e irreversível</b> das informações do usuário, em conformidade
            com a<b> Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018)</b> e boas práticas internacionais de
            proteção de dados.
          </Paragraph>
          <Title level={3}>4. Exceções Legais</Title>
          <Paragraph>
            Em casos em que a legislação aplicável exigir a retenção de determinados registros (como obrigações fiscais,
            contratuais ou judiciais), os dados poderão ser mantidos estritamente pelo prazo legal necessário, sendo
            eliminados de forma definitiva após esse período.
          </Paragraph>
        </Typography>
      </PrivacyBox>
      <Footer bg="transparent" color="#fff" />
    </Layout>
  );
}
